export const ACCESS = 'access';
export const READ_PCK = 'read_pck';
export const EDIT_PCK = 'edit';
export const EXPORT = 'export';
export const EDIT_ACTUAL = 'edit_actual';
export const READ_COMPLETED = 'read_completed';
export const READ_MANUFACTURING_ORDERS = 'read_manufacturing_orders';
export const ASSIGN_PCK = 'assign_pck';
export const REOPEN_PCK = 'reopen_pck';
